// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"_1N76kv","icon":"_21HVTA","rightArrowSmall":"_2z5nU1","dummy":"NhE-wQ","dummyCompactMobile":"_2B-n3g","dummyCompact":"_2VsQYj","shine-lines":"_2-OygS"};